/* eslint-disable require-jsdoc */
/* eslint-disable no-unused-vars */

import React from 'react';
import routes from '../navigation/Routes';
import {Link} from 'react-router-dom';
// eslint-disable-next-line max-len
import {MuiListItem, MuiListItemText, muiWithStyles, MuiButton, MuiTypography} from './MaterialUIComponents';
import {Grid} from '@material-ui/core';

const menuStyle = (theme)=> ({
  listItem: {
    textDecoration: 'none',
    color: 'red',
    paddingTop: 16,
  },
  buttonStyle: {

    height: '100%',
  },
});

class MenuItems extends React.Component {
  render() {
    const {classes}=this.props;
    return (

      <Grid container direction='row' >
        <Link className={classes.listItem} to={routes.home} >
          <MuiButton>
            <MuiTypography>
            home
            </MuiTypography>
          </MuiButton>
        </Link>
        <Link className={classes.listItem} to={routes.aboutUs}>
          <MuiButton >
            <MuiTypography>
            About us
            </MuiTypography>
          </MuiButton>

        </Link>
        <Link className={classes.listItem} to={routes.services} >
          <MuiButton style={{height: '100%'}}>
            <MuiTypography>
            Services
            </MuiTypography>
          </MuiButton>
        </Link>
        <Link className={classes.listItem} to={routes.contactUs} >
          <MuiButton style={{height: '100%'}}>
            <MuiTypography>
            Contact Us
            </MuiTypography>
          </MuiButton>

        </Link>
        {/* <Link className={classes.listItem} to={routes.resources} >
          <MuiButton style={{height: '100%'}}>
            <MuiTypography>
            Resources
            </MuiTypography>
          </MuiButton>

        </Link> */}
      </Grid>

    );
  }
}

export default muiWithStyles(menuStyle)(MenuItems);

